import { motion } from "framer-motion";
import { Eyebrow } from "./ui-kit";
import { MaskLine } from "../lib/motion";

export const PageHeader = ({ eyebrow, title, sub, image }) => (
  <section className="relative pt-[72px] bg-[#0A0A0A] text-white grain overflow-hidden">
    {image && (
      <>
        <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/60 to-[#0A0A0A]/70" />
      </>
    )}
    <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8 pt-24 pb-20 sm:pt-32 sm:pb-28">
      <Eyebrow dark>{eyebrow}</Eyebrow>
      <h1 className="font-display font-extrabold tracking-tight text-5xl sm:text-6xl lg:text-[5rem] leading-[1.02] max-w-4xl">
        {title.split("\n").map((l, i) => <MaskLine key={`${l}-${i}`} delay={i * 0.12}>{l}</MaskLine>)}
      </h1>
      {sub && (
        <motion.p
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4, duration: 0.7 }}
          className="mt-7 text-white/70 text-lg max-w-2xl leading-relaxed"
        >
          {sub}
        </motion.p>
      )}
    </div>
  </section>
);
